export const Authenticating: React.FC = () => {
  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
      <div className='text-center'>
        <div className='animate-spin rounded-full h-[40px] w-12 border-2 border-gray-200 border-t-blue-600 mx-auto mb-4'></div>
        <h2 className='text-lg font-medium text-gray-900 mb-2'>
          Authenticating...
        </h2>
        <p className='text-gray-600'>
          Please wait while we verify your credentials.
        </p>
      </div>
    </div>
  );
};
